import styled from '@emotion/styled';
import { RemoveTrashIcon } from 'src/assets/icons/RemoveTrashIcon';

export const TrashIconWrapper = styled(RemoveTrashIcon, { label: 'TrashIconWrapper' })`
    fill: currentColor;
    flex: 0 0 16px;
    height: 16px;
`;
